<template>
  <transition name="top" appear>
    <q-page-sticky position="top-right" :offset="[11, 11]">
      <btn-hold
          v-if="aux[0]"
          round
          :wait-for-ripple="true"
          align="right"
          content-class="pop-dd"
          :color="btns[0].color"
          :icon="btns[0].icon"
          @click="btns[0].click"
      >
        <q-btn
            v-for="(btn, index) in aux"
            :key="index"
            v-if="!btn.hide"
            :color="btn.color"
            @click="btn.click"
            :icon="btn.prefix?'':btn.icon"
            round
        >
          <template v-if="btn.prefix">
            <span>+</span>
            <q-icon :name="btn.icon" size="20px"></q-icon>
          </template>
        </q-btn>
      </btn-hold>
      <q-btn
        v-else
        round
        :color="btns[0].color"
        :icon="btns[0].icon"
        @click="btns[0].click"
      >
      </q-btn>
    </q-page-sticky>
  </transition>
</template>
<style>
</style>

<script>
import BtnHold from './btn-hold.vue';

export default {
  name: 'popHold',
  components: { BtnHold },
  props: {
    btns: {
      type: Array,
      required: true,
    },
  },
  computed: {
    aux() {
      return this.btns.slice(1).filter(item => !item.hide);
    },
  },
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pop-hold.vue